// Header.js
import React from "react";
import watchHeader from "../../assets/watch-header.jpeg";
import "./Header.css";

const WatchHeader = () => {
  return (
    <div className="watch-headerc">
      <div className="purple-circle"></div>
      <div className="purple-ellipse"></div>
      <div className="header-content">
        <div className="header-text mt-10 ml-2">
          <h1>Watch</h1>
          <p>Watch your live race and track token performance here.
          </p>
        </div>
        <div className="watch-header-image">
          <img src={watchHeader} alt="Race Wizard" width={250} />
        </div>
      </div>
    </div>
  );
};

export default WatchHeader;
